import { render, staticRenderFns } from "./GhostControlOverlay.vue?vue&type=template&id=3dbfabc2&scoped=true"
import script from "./GhostControlOverlay.vue?vue&type=script&lang=js"
export * from "./GhostControlOverlay.vue?vue&type=script&lang=js"
import style0 from "./GhostControlOverlay.vue?vue&type=style&index=0&id=3dbfabc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfabc2",
  null
  
)

export default component.exports